import React from "react"

import { DefaultLayout } from "../layouts"
import { Hero, SEO, Section, Pricing, Faq } from "../components"
import { Grid, Typography } from "@material-ui/core"

const faqs = [
  {
    primaryText: "What is a Connection?",
    secondaryText:
      "A connection in Kovalt is an automated link between your Neto site and remote sites which synchronises order and product data between the two. See features for more information.",
  },
  {
    primaryText: "What does Update Time mean?",
    secondaryText:
      "Update time is the frequency at which Kovalt synchronises orders and products between your Neto site and remote sites. For orders this is the frequency Kovalt checks for new orders in the remote site and uploads updates to the remote site. For products this is the frequency that Kovalt checks for changes in Neto and synchronises them to the remote site.",
  },
  {
    primaryText: "Why are there monthly costs?",
    secondaryText:
      "The monthly costs cover the server usage that each connection needs to operate. In addition, any support required for the integration and the development of new integrations.",
  },
  {
    primaryText: "Do these costs include fees charged by each marketplace?",
    secondaryText:
      "No, these costs do not include any fees or onboarding charges by each marketplace or remote site. These costs cover the ongoing integration service only.",
  },
  {
    primaryText: "What is a prioritised feature request?",
    secondaryText:
      "A feature request could be a feature that you'd like in an existing integration, or as large as a new integration altogether. Having priority means these requests have weighted consideration.",
  },
  {
    primaryText: "Can I connect to other marketplaces that aren’t listed?",
    secondaryText:
      "Only the listed marketplaces have tested and functioning integrations. Check the roadmap page for a list of marketplaces that are completed and being worked on.",
  },
  {
    primaryText: "Can I use Kovalt to connect a different eCommerce package to these marketplaces?",
    secondaryText:
      "No, Kovalt is specifically designed to fulfil the needs of merchants using Neto eCommerce. ",
  },
]

const PricingPage = () => (
  <DefaultLayout>
    <SEO title="Pricing" />
    <Section>
      <Hero primaryText="Pricing" secondaryText="All prices are in AUD" />
    </Section>
    <Section>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Pricing
            primaryText="One"
            secondaryText="Perfect for selling on the channel that’s right for you."
            price={30}
            inclusions={["1 Connection", "20 Min Update Time"]}
            features={["Unlimited Historical Sync Data", "Email Support"]}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Pricing
            primaryText="Two"
            secondaryText="For expanding your selling potential on multiple channels."
            price={45}
            inclusions={["2 Connections", "10 Min Update Time"]}
            features={["Unlimited Historical Sync Data", "Email Support"]}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Pricing
            primaryText="Three"
            secondaryText="For power sellers who want to be on the bleeding edge."
            price={65}
            inclusions={["3 Connections", "5 Min Update Time"]}
            features={[
              "Unlimited Historical Sync Data",
              "Email Support",
              "Phone Support",
              "Prioritised Feature Requests",
            ]}
          />
        </Grid>
      </Grid>
    </Section>
    <Section>
      <Typography variant="h2" align="center" style={{ marginBottom: 24 }}>
        Frequently Asked Questions
      </Typography>
      {faqs.map((props, k) => (
        <Faq {...props} key={k} />
      ))}
    </Section>
  </DefaultLayout>
)

export default PricingPage
